define('gigaset_recurring/components/catalog/product/plan/configurable/options',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware/components/Config",
	"text!./options/templates/badge.html",
], function(
	$,
	_,
	Component,
	BEM,
	Config,
	BadgeOptionTemplate
) {

	//var INSTALLED = false;

	var templates = {
		badge: _.template(BadgeOptionTemplate),
		price: null
	};

	return Component.create({
		priceBlock: null,

		init: function() {
			var self = this;

			// TODO implement destructor for add-to-cart within category listing
			// Why we need this while on magnific popup close DOM nodes are removed and GC takes care of events bound to them? Then another click happens > AJAX > new events should be bounded to new DOM nodes inside new magnific popup.
			//if (!INSTALLED) {
				var data = window.spConfigData;
				var planVariant = null;

				var _fillSelect = Product.Config.prototype.fillSelect;
				Product.Config.prototype.fillSelect = function(element) {
					_fillSelect.apply(this, arguments);
					_.forEach(element.options, function(option) {
						if (!option.value) return;

						var plan = _.get(data, ['plan_variants', option.value]);

						if (plan) {
							$(option).data('tmpl', templates.badge({ plan: plan }));
						}
					});
				};

				var _reloadPrice = Product.Config.prototype.reloadPrice;
				Product.Config.prototype.reloadPrice = function() {
					if (this.config.disablePriceReload) {
						return;
					}
					var price    = 0;

					var oldPrice = 0;
					for(var i=this.settings.length-1;i>=0;i--){
						var selected = this.settings[i].options[this.settings[i].selectedIndex];
						if(selected.config){
							price    += parseFloat(selected.config.price);
							oldPrice += parseFloat(selected.config.oldPrice);
						}

						if ("plan_variant_id" === this.settings[i].name) {
							planVariant = _.get(data, ['plan_variants', selected.value]);
							optionsPrice.productPrice = _.get(planVariant, 'price.recurring_fee');
							self.renderPlanPrice(planVariant);
						}
					}

					optionsPrice.changePrice('config', {'price': price, 'oldPrice': oldPrice});
					// optionsPrice.reload();

					return price;
				};

				var _reload = Product.OptionsPrice.prototype.reload;
				Product.OptionsPrice.prototype.reload = function() {
					planVariant && self.renderPlanPrice(planVariant);
					return _reload.apply(this, arguments);
				};

			//	INSTALLED = true;
			//}
		},

		renderPlanPrice: function(planVariant) {
			var planPrice			= _.get(planVariant, 'price');

			if (null === this.priceBlock) {
				this.priceBlock = BEM.block($('#' + optionsPrice.containers[0]).parents("." + BEM.buildBlockClassname("price")));
			}

			if (null === templates.price) {
				templates.price = _.template(this.priceBlock.find("[data-template]").html());
			}

			var unitMap = {
				'Day':		'Days',
				'Week':		'Weeks',
				'Month':	'Months',
				'Year':		'Years'
			};

			var html = templates.price({
				planVariant:		planVariant,
				printPeriod:		function(period) {
					var qty = _.get(period, 'quantity');
					var unit = _.get(period, 'unit');
					return qty + ' ' +  window.Translator.translate(qty > 1 && unit in unitMap ? unitMap[unit] : unit)
				},
				formatPrice:		$.proxy(optionsPrice.formatPrice, optionsPrice),
				tax_type:			planPrice.tax_type,
				__:					window.Translator.translate
			});

			this.priceBlock.html(html);
		}
	});
});
